import { name } from "./block.json";

const rot13 = str => {
	const input = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
	const output = 'NOPQRSTUVWXYZABCDEFGHIJKLMnopqrstuvwxyzabcdefghijklm';
	let encoded = '';

	for (let i=0; i < str.length; i++) {
		const index = input.indexOf(str[i]);
		encoded += -1 !== index ? output[index] : str[i];
	}

	return encoded;
}

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLElement) {
	const emailPlaceholder = block.querySelector<HTMLDivElement>('.wp-block-site-person-card__email-link');

	const user = emailPlaceholder?.dataset.user
	const domain = emailPlaceholder?.dataset.domain

	if (!user || !domain) {
		return;
	}

	const email = rot13(user.split("").reverse().join("")) + '@' + rot13(domain);

	const emailLink = document.createElement('a');
	emailLink.classList.add('wp-block-site-person-card__email-link');
	emailLink.href = 'mailto:' + email;
	emailLink.title = email;
	emailLink.innerHTML = email;

	emailPlaceholder.replaceWith(emailLink);
}
